import { render, staticRenderFns } from "./TermConditionofUse.vue?vue&type=template&id=22fd35bd&scoped=true&lang=html"
import script from "./TermConditionofUse.vue?vue&type=script&lang=js"
export * from "./TermConditionofUse.vue?vue&type=script&lang=js"
import style0 from "./TermConditionofUse.vue?vue&type=style&index=0&id=22fd35bd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd35bd",
  null
  
)

export default component.exports